export enum CopType {
	BUILDER = 'builder',
	CUBE_CAMERA = 'cubeCamera',
	VIDEO = 'video',
	WEB_CAM = 'webCam',
	SNAPSHOT = 'snapshot',
}
